export default __webpack_public_path__ + "static/media/ic-schedule-active.d3511702.svg";